import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1,
    },
    balance: {
        data: [],
        countPage: 1
    },
    jackpot: {
        data: [],
        countPage: 1
    },
    bonuses: {
        data: [],
        countPage: 1
    },
    view: {
        ggr: 0,
    },
    list_replenishment: {
        replenishment: []
    },
    list_withdrawal: {
        withdrawal: []
    }
}

export function mobileHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_HISTORY_LIST:
            return { ...state, list: action.payload};
        case types.SET_CASHIERS_PROFILE:
            return { ...state, balance: action.payload};
        case types.SET_HISTORY_JACKPOT:
            return { ...state, jackpot: action.payload};
        case types.SET_HISTORY_BONUSES:
            return { ...state, bonuses: action.payload};
        case types.SET_GGR:
            return { ...state, view: action.payload};
        case types.SET_OPERATION_REPLENISHMENT:
            return { ...state, list_replenishment: action.payload};
        case types.SET_OPERATION_WITHDRAWAL:
            return { ...state, list_withdrawal: action.payload};
        default:
            return state
    }
}